import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PositiveNumberValidator } from "src/app/directives/positive-number.directive";
import { ConfigCesion } from "src/app/models/Cesion/ConfigCesion";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import Swal from "sweetalert2";

@Component({
   selector: "app-configuracion-cesion-entry",
   templateUrl: "./configuracion-cesion-entry.component.html",
   styleUrls: ["./configuracion-cesion-entry.component.scss"],
})
export class ConfiguracionCesionEntryComponent implements OnInit {
   public configForm: FormGroup;
   public emisorId: string;
   @Input() public detailMode: boolean = false;
   @Input() public editMode: boolean = false;
   @Input() public configToEdit: ConfigCesion = undefined;
   @Input() public noEditTypeDte: boolean = false;
   @Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
   @Output() private sendCesionConfigRequest: EventEmitter<any> = new EventEmitter<any>();
   private configObj: ConfigCesion = new ConfigCesion();
   constructor(private localStorage: LocalStorageService, private formBuilder: FormBuilder, private tokenService: TokenStorageService) {
      this.emisorId = this.tokenService.getCompany();
   }

   ngOnInit(): void {
      this.setConfigForm();
      if (this.configToEdit) {
         this.setConfigDataToForm(this.configToEdit);
      }
   }

   setConfigForm() {
      this.configForm = this.formBuilder.group({
         diasVencimiento: ["", [Validators.required, PositiveNumberValidator]],
      });
   }

   onSubmit() {
      if (this.configForm.valid) {
         this.getFormData();
         this.sendCesionConfigRequest.emit(this.configObj);
      }
   }

   sendCloseRequest() {
      this.sendCloseRequestEmitter.emit();
   }

   getFormData() {
      this.configObj.diasVencimiento = this.configForm.controls.diasVencimiento.value;
      this.configObj.emisorId = this.configToEdit.emisorId;
   }

   setConfigDataToForm(config: ConfigCesion) {
      this.configForm.patchValue(config);
      this.configForm.get("diasVencimiento").patchValue(config.diasVencimiento);
   }
}
